import React from 'react';
import { AlertTriangle, TrendingUp, TrendingDown, CalendarDays } from 'lucide-react';

const AnomalyCard = ({ anomaly, unit = '' }) => {
    const { paramName, date, previousDate, value, previousValue, changePercent, type, deviceName } = anomaly;

    const isIncrease = changePercent > 0;
    const isCritical = Math.abs(changePercent) > 50;

    return (
        <div className={`bg-slate-800 rounded-xl border p-4 transition hover:shadow-lg hover:-translate-y-0.5 ${isCritical ? 'border-red-500/50' : 'border-yellow-500/30'
            }`}>
            <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                    <AlertTriangle className={`w-4 h-4 ${isCritical ? 'text-red-400' : 'text-yellow-400'}`} />
                    <span className="text-white font-medium text-sm">{paramName}</span>
                </div>
                <span className={`px-2 py-0.5 rounded text-xs font-semibold ${isCritical ? 'bg-red-500/20 text-red-300' : 'bg-yellow-500/20 text-yellow-300'
                    }`}>
                    {type === 'spike' ? 'Скачок ↑' : 'Провал ↓'}
                </span>
            </div>

            {/* Дата аномалии */}
            <div className="text-xs text-slate-400 mb-1 flex items-center gap-1">
                <CalendarDays className="w-3 h-3" />
                {date}
            </div>

            <div className="flex items-center gap-3">
                <div className="text-lg font-bold text-white">
                    {value?.toFixed(3)} <span className="text-xs text-slate-400 font-normal">{unit}</span>
                </div>
                <div className={`flex items-center gap-1 text-sm font-semibold ${isIncrease ? 'text-red-400' : 'text-blue-400'
                    }`}>
                    {isIncrease ? <TrendingUp className="w-4 h-4" /> : <TrendingDown className="w-4 h-4" />}
                    {isIncrease ? '+' : ''}{changePercent.toFixed(1)}%
                </div>
            </div>

            {/* ✅ Понятная подпись: значение за предыдущие сутки с датой */}
            <div className="text-xs text-slate-500 mt-2 pt-2 border-t border-slate-700">
                Предыдущие сутки ({previousDate}):{' '}
                <span className="text-slate-300 font-mono">{previousValue?.toFixed(3)} {unit}</span>
            </div>
        </div>
    );
};

export default AnomalyCard;